export const NAME_MAX_LENGTH = 250;

export const ADDRESS_STREET_MAX_LENGTH = 250;
export const ADDRESS_CITY_MAX_LENGTH = 50;
export const ADDRESS_COUNTY_MAX_LENGTH = 100;
export const ADDRESS_ZIP_MAX_LENGTH = 10;

export const YEAR_MAX_LENGTH = 4;
